export default {
  methods: {
    /**
     * Calculates states.
     *
     * @param {object} obj Object that contains the values to process.
     * @param {[string]} states State field names to calculate.
     * @param {string} name Name of the key to store states into.
     * @param {string} stateField Field name to store the states in.
     */
    processStates(obj, states, name, stateField) {
      for (const state of states) {
        let setState = false;
        const f = obj[state];
        if (_.isBoolean(f)) {
          setState = f;
        } else if (_.isFunction(f)) {
          const ok = f();
          if (ok instanceof Promise) {
            ok.then(r => {
              this.$set(this[stateField], name, { ..._.get(this, [stateField, name], {}), [state]: r });
            });
          } else {
            setState = ok;
          }
        }
        this.$set(this[stateField], name, { ..._.get(this, [stateField, name], {}), [state]: setState });
      }
    },
  },
};
